export default "__VITE_ASSET__CFJD0oen__"